import { Text } from '@change/ds-core-ui';

import star from '#src/assets/payment/star.svg';

import { useAverageAmountMessage } from './hooks/useAverageAmountMessage';

export const AverageAmountMessage: React.FC = () => {
	const {
		data: { display, variant, localizedAverageAmount },
	} = useAverageAmountMessage();
	if (!display) return null;

	if (variant === 'variant_2') {
		return (
			<div className="bg-fill-selected-weaker border-stroke-info-weak rounded-medium mt-1 flex flex-row gap-1.5 border px-4 py-3">
				<img src={star} alt="star" className="h-5 w-5" />
				<Text className="text-typography-information" size="x-small" fontWeight="normal">
					{/* TODO: add translation when productized */}
					{localizedAverageAmount}/month is the most popular contribution
				</Text>
			</div>
		);
	}

	return (
		<div className="border-stroke-info-weak rounded-medium mt-1 flex flex-row items-center justify-between gap-1.5 border px-4 py-3">
			<Text className="text-typography-information" size="small" fontWeight="normal">
				{/* TODO: add translation when productized */}
				Average contribution:
			</Text>
			<Text className="text-typography-information" size="small" fontWeight="bold">
				{/* TODO: add translation when productized */}
				{localizedAverageAmount}/month
			</Text>
		</div>
	);
};
